function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8 15.333c-4.05 0-7.334-3.284-7.334-7.334S3.949.666 7.999.666c4.05 0 7.334 3.283 7.334 7.333 0 4.05-3.284 7.334-7.334 7.334zm0-1.334c3.313 0 6-2.686 6-6 0-3.313-2.687-6-6-6-3.314 0-6 2.687-6 6 0 3.314 2.686 6 6 6zm-2.196-2.862L8 8.942l2.196 2.195.942-.942-2.195-2.196 2.195-2.195-.942-.943-2.196 2.196L5.804 4.86l-.943.943L7.057 8 4.86 10.195l.943.942z",
  clipRule: "evenodd"
});

var SvgCrossCircle = function SvgCrossCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrossCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CrossCircle.92a36c9d.svg";
export { ForwardRef as ReactComponent };